// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const fetchKitColumns = createAction('orderByKit/fetch-columns', function prepare({ tableId }) {
	return { payload: { tableId } };
});

export const fetchKitOrderData = createAction(
	'orderByKit/fetch-order-data',
	function prepare({ tableId, orderStatusValue, refreshKey }) {
		return { payload: { tableId, orderStatusValue, refreshKey } };
	}
);

export const fetchKitAvailability = createAction(
	'orderByKit/fetch-kit-availability',
	function prepare({ kitId }) {
		return { payload: { kitId } };
	}
);
